import { getParam } from 'utilsES'
let params = {}
//是否sdk
export const isSdk = getParam('devicePlate')
//是否安卓
export const IS_ANDROID = getParam('devicePlate') == 'android'
//关闭页面
export const sdkCloseWebview = () => {
	if (IS_ANDROID) {
		try {
			window.sdkCtrl.closeWebview()
		} catch (error) {}
	} else {
		try {
			window.webkit.messageHandlers.callSDKMethodWithParameters.postMessage({ method: 'closeWebview', params })
		} catch (error) {}
	}
}
//隐藏导航栏
export const sdkHideTopBar = () => {
	if (IS_ANDROID) {
		try {
			window.sdkCtrl.callSDKMethodWithParameters('hideNavigationView', '')
		} catch (error) {}
	} else {
		try {
			window.webkit.messageHandlers.callSDKMethodWithParameters.postMessage({
				method: 'hideNavigationView',
				params
			})
		} catch (error) {}
	}
}
export const sdkOpenLink = link => {
	let paramsObj = {
		url: link,
		loginDir: 0,
		appendParams: 0
	}
	let paramsStr = JSON.stringify(paramsObj)
	if (IS_ANDROID) {
		try {
			window.sdkCtrl.callSDKMethodWithParameters('openBrowser', paramsStr)
		} catch (error) {}
	} else {
		try {
			window.webkit.messageHandlers.callSDKMethodWithParameters.postMessage({
				method: 'openBrowser',
				params: paramsObj
			})
		} catch (error) {
		}
	}
}
